// eslint-disable-next-line import/prefer-default-export
export const reportGetters = {
    filters(state) {
        return state.filters
    }
};
